<template>
  <div class="wrap-content">
    <div class="content-wrap">
      <el-card>
        <el-row class="mb-16" type="flex">
          <el-col :span="6"></el-col>
          <el-col :span="18" class="right-col">
            <el-input
              v-model="params.keywords"
              :placeholder="$t('system::team::search_name')"
              style="width: 200px"
              clearable
              @keyup.native.enter="() => getList()"
            >
              <i slot="prefix" class="el-icon-search" style="line-height: 36px" @click="() => getList()"></i>
            </el-input>
            <el-button @click="onAddStaff" style="margin-left: 12px" type="primary" icon="el-icon-plus">
              {{ $t('system::team::add_staff') }}
            </el-button>
          </el-col>
        </el-row>

        <z-table
          :columns="columns"
          :data="tableData"
          height="540px"
          v-loading="loading"
          :pagination.sync="pagination"
          @page-change="() => getList()"
        >
          <template #operate="{ row }">
            <el-button type="text" @click="editStaff(row)">
              {{ $t('system::function::edit') }}
            </el-button>
            <el-button type="text" style="color: red" @click="deleteUser(row)">
              {{ $t('system::team::delete') }}
            </el-button>
          </template>
        </z-table>
      </el-card>
    </div>
    <addStaff :teamData="treeData" v-model="isShowAdd" :drawRow="drawRow" @refresh="getList()"></addStaff>
  </div>
</template>

<script>
import addStaff from './components/add-staff.vue'
import { teamList, teamStaff, teamStaffDel } from '@/server/team-manage'
import { columnsTeam } from '../config'
export default {
  name: 'staff-list',
  components: { addStaff },

  props: {
    selected: {
      default: () => {},
    },
    treeData: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    selected: {
      handler: function (data) {
        this.getList()
      },
      deep: true,
      immediate: true,
    },
    'params.keywords'(val) {
      this.getList(val)
    },
  },
  data() {
    return {
      isShowAdd: false,
      drawRow: {
        type: 'add',
        data: {},
      },
      columns: columnsTeam,
      loading: false,
      visible: false,
      params: {
        keywords: '',
      },
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      tableData: [],
      editUserId: '',
    }
  },

  methods: {
    async getList() {
      this.loading = true
      let data = this.selected
      let params = {
        type: data.type,
        teamId: data.id,
      }
      const res = await teamStaff({
        ...params,
        ...this.params,
        ...this.pagination,
      })
      this.loading = false
      console.log(res.data.data)
      if (res.data.code === this.$code) {
        this.tableData = res.data.data.items
        this.pagination.total = res.data.data.totalCount
      }
    },
    deleteUser(row) {
      this.$confirm(`<p style="color: #aaa">${this.$t('system::team::user_delete')}</p>`, '删除员工', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        closeOnClickModal: false,
      }).then(async () => {
        const { data } = await teamStaffDel({
          teamId: row.teamId,
          userId: row.userId,
        })
        if (data.code === this.$code) {
          this.$message.success(this.$t('system::tip::delete_success'))
          this.getList(this.selected)
        }
      })
    },
    onAddStaff() {
      this.drawRow = {
        type: 'add',
        data: {
          keyword: '',
          teamId: this.selected.id || '',
          roleId: [],
        },
      }

      this.isShowAdd = true
    },
    editStaff(row) {
      this.drawRow = {
        type: 'edit',
        data: { keyword: row.loginName, roleId: row.roleList ? row.roleList.map(el => el.roleId) : [], ...row },
      }
      this.isShowAdd = true
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap-content {
  /deep/.el-card__body {
    padding: 0;
  }
}
</style>
